/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useOverlayFormWithControlsStyles = makeStyles(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    paddingBottom: '20px',
  },
  formNotGrow: {
    flex: 0,
  },
  formChildren: {
    flex: '1 0 auto',
  },
  formControls: {
    marginTop: '40px',
    flex: '0 0 auto',
  },
  formButtons: {
    '& + $stepsIndicator': {
      marginTop: '50px',
    },
    '& > *:not(:first-child)': {
      marginLeft: '16px',
    },
  },
  stepsIndicator: {},
}));
